<template>
    <main>
  <div  class="container loader-image-circle-for-iframe" style="height: inherit;">
          <iframe
            :src="iframe.src"
            width="100%"
            height="100%"
            frameborder="0" >
           </iframe>
    </div>
     </main>
</template>
 <script>
 import url from "../../config/url";
 export default {
  data() {
    return {
      loaded: false,
      iframe: {
        src:null,
        style: null,
        wrapperStyle: null,
      }
    }  
  },
 computed: {
   /**
     * Get current Podio user
     */
    podioUser: function() {
      return this.$store.state.auth.podio_user;
    },
    /**
     * Get user itemId from the podio user object
     */
      itemId: function() {
        return  this.podioUser.itemId;
      }
},
 mounted() {
    if(this.podioUser.itemId != undefined){
    this.iframe.src = url.sicknessRequest_sickness_requests_webform_link+"?fields[employee-2]="+this.podioUser.itemId;  
    this.loaded = true;
    }
  },
   watch: {
	itemId: function(){
    this.iframe.src = url.sicknessRequest_sickness_requests_webform_link+"?fields[employee-2]="+this.podioUser.itemId;  
    this.loaded = true;
	}
   }
 }

 
 
 </script>